import { mediaUrl } from '../api';
import useAuth from '../auth/useAuth';
import { MvCover } from './brand/MvLandscape';

/**
 * A news item written without a cover still shows the megaphone the migrated
 * news rows carry, so every news surface has an icon in the same place.
 */
export const NEWS_ICON_FALLBACK = 'fa-solid fa-bullhorn';

/**
 * `articles.icon` holds two kinds of value. Rows migrated from the news table
 * carry a Font Awesome class ("fa-solid fa-bullhorn"); anything set since the
 * editor gained its cover-image box carries a media path. Both have to render
 * until the class values are gone, and the shape of the value is the only thing
 * that says which is which. A publication with no icon gets a generated MV
 * landscape cover when a `seed` (its title) is given, otherwise `fallback`
 * (see NEWS_ICON_FALLBACK).
 */
function ArticleIcon({ icon, className = '', alt = '', fallback = null, seed }) {
  const { preferences } = useAuth();

  // The generated cover is part of the MV look; the classic theme keeps the
  // plain fallback icon it always had.
  if (!icon && seed && preferences?.theme !== 'classic') {
    return <MvCover seed={seed} className={className} />;
  }

  const value = icon || fallback;

  if (!value) {
    return null;
  }

  const isImage =
    value.startsWith('/') ||
    value.startsWith('http') ||
    value.startsWith('data:');

  if (isImage) {
    return (
      <img
        className={['article-icon-image', className]
          .filter(Boolean)
          .join(' ')}
        src={mediaUrl(value)}
        alt={alt}
      />
    );
  }

  return (
    <i
      className={[value, className].filter(Boolean).join(' ')}
      aria-hidden="true"
    />
  );
}

export default ArticleIcon;
